(function () {
  /* Set this to the deployed tracking-worker URL to enable real view counting
     (see /worker/README.md). Left blank, tracking is a no-op and videos keep
     their existing (metaobject) order. */
  var TRACK_ENDPOINT = 'https://sportshero-video-view-tracker.niek-6f4.workers.dev';
  window.shCommunityTrackUrl = TRACK_ENDPOINT;

  var PLAY_VIDEO_LABEL = (window.SH_I18N && window.SH_I18N.community_slider_play_video_label) || 'Video afspelen';
  var DOT_LABEL_TEMPLATE = (window.SH_I18N && window.SH_I18N.community_slider_dot_label) || 'Ga naar video {n}';

  function buildCard(v) {
    var card = document.createElement('div');
    card.className = 'sh-u';
    if (v.id) card.setAttribute('data-track-id', v.id);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sh-ugc-play-trigger';
    btn.setAttribute('data-sh-video-trigger', '');
    btn.setAttribute('aria-label', PLAY_VIDEO_LABEL);

    if (v.poster) {
      var img = document.createElement('img');
      img.src = v.poster;
      img.loading = 'lazy';
      img.alt = '';
      img.className = 'sh-vposter';
      btn.appendChild(img);
    }
    if (v.duration) {
      var dur = document.createElement('span');
      dur.className = 'sh-vdur';
      dur.textContent = v.duration;
      btn.appendChild(dur);
    }
    var play = document.createElement('span');
    play.className = 'sh-ugc-play';
    play.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
    btn.appendChild(play);
    card.appendChild(btn);

    var tpl = document.createElement('template');
    tpl.setAttribute('data-sh-video-src', '');
    tpl.innerHTML = '<video class="sh-vid-el" autoplay playsinline preload="none"><source src="' + v.src + '" type="video/mp4"></video>';
    card.appendChild(tpl);

    return card;
  }

  function setupArrows(wrap, track) {
    var prev = wrap.querySelector('[data-sh-ugc-prev]');
    var next = wrap.querySelector('[data-sh-ugc-next]');
    if (!prev || !next) return;

    function cardStep() {
      var card = track.querySelector('.sh-u');
      var w = card ? card.getBoundingClientRect().width : 200;
      return (w + 14) * 2;
    }
    function update() {
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      var scrollable = track.scrollWidth > track.clientWidth + 4;
      prev.style.display = (!scrollable || atStart) ? 'none' : 'flex';
      next.style.display = (!scrollable || atEnd) ? 'none' : 'flex';
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: cardStep(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    setTimeout(update, 300);
  }

  function setupDots(wrap, track) {
    var dotsWrap = wrap.querySelector('[data-sh-ugc-dots]');
    if (!dotsWrap) return;

    function build() {
      var cards = Array.prototype.slice.call(track.children);
      dotsWrap.innerHTML = '';
      var scrollable = track.scrollWidth > track.clientWidth + 4;
      dotsWrap.hidden = !scrollable || !cards.length;
      if (!scrollable) return;
      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sh-hslider-dot';
        dot.setAttribute('aria-label', DOT_LABEL_TEMPLATE.replace('{n}', i + 1));
        dot.addEventListener('click', function () {
          card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsWrap.appendChild(dot);
      });
      updateActive();
    }

    function updateActive() {
      var cards = Array.prototype.slice.call(track.children);
      var dots = Array.prototype.slice.call(dotsWrap.children);
      if (!cards.length || !dots.length) return;
      var trackRect = track.getBoundingClientRect();
      var closest = 0, closestDist = Infinity;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.getBoundingClientRect().left - trackRect.left);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      dots.forEach(function (d, i) { d.classList.toggle('sh-on', i === closest); });
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateActive, 80);
    }, { passive: true });
    window.addEventListener('resize', build);

    setTimeout(build, 300);
  }

  var trackEntries = [];

  document.querySelectorAll('[data-sh-ugc-track]').forEach(function (track) {
    var jsonId = track.getAttribute('data-videos-json');
    var script = jsonId ? document.querySelector('script[data-sh-community-json="' + jsonId + '"]') : null;
    if (!script) return;

    var videos;
    try {
      videos = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    var wrap = track.closest('.sh-pdp-ugc-slider-wrap');
    var maxAttr = wrap ? wrap.getAttribute('data-max-videos') : null;
    var max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
    if (!max || isNaN(max)) max = Infinity;
    var productFilter = wrap ? wrap.getAttribute('data-product-filter') : null;
    var requireProductFlag = wrap ? wrap.getAttribute('data-require-product-flag') === 'true' : false;
    var locale = wrap ? (wrap.getAttribute('data-locale') || '').toLowerCase() : '';
    var currentLang = locale.split('-')[0];

    var list = videos;
    if (requireProductFlag) {
      list = list.filter(function (v) {
        return v.showOnProduct === true;
      });
    }
    if (productFilter) {
      list = list.filter(function (v) {
        return v.products && v.products.indexOf(productFilter) !== -1;
      });
    }
    list = list.filter(function (v) {
      if (!v.lang || v.lang.length === 0) return true;
      return v.lang.indexOf(currentLang) !== -1;
    });

    // Render immediately using the metaobject's own viewCount (usually 0) as
    // a tiebreaker, so the slider never waits on a network round trip to
    // the tracking worker before showing anything.
    list = list.slice().sort(function (a, b) {
      return (b.viewCount || 0) - (a.viewCount || 0);
    });
    list = list.slice(0, max).filter(function (v) { return v && v.src; });

    var entries = list.map(function (v) {
      var el = buildCard(v);
      track.appendChild(el);
      return { v: v, el: el };
    });
    trackEntries.push({ track: track, entries: entries });

    if (wrap) {
      setupArrows(wrap, track);
      setupDots(wrap, track);
    }
  });

  // Fetch real view counts in the background and, if they change the order,
  // silently re-sort the already-rendered cards (no re-fetching, no re-paint
  // flash — just reordering existing DOM nodes).
  if (TRACK_ENDPOINT && trackEntries.length) {
    fetch(TRACK_ENDPOINT + '/counts')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (counts) {
        if (!counts) return;
        trackEntries.forEach(function (t) {
          var changed = false;
          var sorted = t.entries.slice().sort(function (a, b) {
            var aCount = (a.v.id && counts[a.v.id] != null) ? counts[a.v.id] : (a.v.viewCount || 0);
            var bCount = (b.v.id && counts[b.v.id] != null) ? counts[b.v.id] : (b.v.viewCount || 0);
            return bCount - aCount;
          });
          sorted.forEach(function (entry, i) {
            if (t.entries[i] !== entry) changed = true;
          });
          if (changed) {
            sorted.forEach(function (entry) { t.track.appendChild(entry.el); });
          }
        });
      })
      .catch(function () {});
  }
})();
